export const translation = {
  'home.hero.title1': 'TOP GYM',
  'home.hero.title2': 'CUMBUCO',
  'home.hero.subtitle': 'Weight training, functional training and classes to keep your routine near the beach.',
  'home.hero.ctaWhatsApp': 'Message on WhatsApp',
  'home.hero.ctaMap': 'View location',
  'home.hero.priceBadge': 'Starting from R$169/month',
  'home.hero.priceBadgeLine1': 'Starting from',
  'home.hero.priceBadgeLine2': 'R$169',
  'home.hero.videoTitle': 'Top Gym Cumbuco - Real training near the beach',
  'home.hero.videoAriaLabel': 'Video of Top Gym Cumbuco gym showing structure and training sessions',

  'home.info.gym': 'Gym in Cumbuco',
  'home.info.classes': 'Weights and classes',
  'home.info.whatsapp': 'WhatsApp for plans',
  'home.info.beach': 'Near Cumbuco Beach',

  'home.info.area.value': '500',
  'home.info.area.label': 'm² of training area',
  'home.info.classes.value': '15',
  'home.info.classes.label': 'Classes per week',
  'home.info.hours.value': '16',
  'home.info.hours.label': 'Hours of operation',
  'home.info.beach.value': '200',
  'home.info.beach.label': 'meters from the beach',

  'home.about.label': 'THE GYM',
  'home.about.title': 'BEACH STRENGTH, REAL TRAINING',
  'home.about.text': 'Top Gym Cumbuco is a gym for those who want to train with structure, guidance and international energy. Whether you are a resident, visitor or someone spending a season in Cumbuco, your training continues here.',
  'home.about.feature1': 'Local environment',
  'home.about.feature2': 'Equipment and free weights',
  'home.about.feature3': 'Close attention',
  'home.about.feature4': 'Options for different goals',
  'home.about.cta': 'Contact us',

  'home.structure.title': 'Full',
  'home.structure.titleHighlight': 'structure',
  'home.structure.subtitle': 'Discover our structure designed for all types of training',

  'home.modalities.title': 'MODALITIES',
  'home.modalities.subtitle': 'Weight training, cross training, functional circuit and muay thai for all levels.',
  'home.modalities.tagPopular': 'Most Popular',

  'home.schedule.title': 'SCHEDULES',
  'home.schedule.subtitle': 'Opening hours and classes to plan your workout',
  'home.schedule.weekday': 'Monday to Friday',
  'home.schedule.weekdayHours': '6 AM to 10 PM',
  'home.schedule.saturday': 'Saturday',
  'home.schedule.saturdayHours': '8 AM to 12 PM',
  'home.schedule.sunday': 'Sunday',
  'home.schedule.sundayHours': 'Closed',
  'home.schedule.classTitle': 'Class Schedule',

  'home.testimonials.title': 'TESTIMONIALS',
  'home.testimonials.rating': '4.9',
  'home.testimonials.navPrev': 'Previous',
  'home.testimonials.navNext': 'Next',

  'home.store.label': 'Our Store',
  'home.store.title': 'FITNESS STORE',
  'home.store.subtitle': 'Fitness fashion, supplements and accessories to boost your workout and healthy lifestyle.',
  'home.store.cta': 'View all products',

  'home.location.title': 'LOCATION',
  'home.location.address': 'Av. Central, 2211 - Praia de Cumbuco, Caucaia - CE, 61619-270',
  'home.location.openMap': 'Open in Google Maps',
  'home.location.reference': 'Located in Cumbuco, just minutes from the beach',

  'home.pricing.title': 'PLANS',
  'home.pricing.subtitle': 'Choose the plan that fits your routine. Message us on WhatsApp to get started.',
  'home.pricing.perMonth': '/month',
  'home.pricing.tagBestValue': 'Best value',
  'home.pricing.cta': 'I want this plan',
  'home.pricing.plan.monthly.name': 'Monthly Weight Training',
  'home.pricing.plan.monthly.price': 'R$ 169',
  'home.pricing.plan.monthly.description': 'Full access to the weight training area.',
  'home.pricing.plan.combo.name': 'Weights + 1 Modality',
  'home.pricing.plan.combo.price': 'R$ 180',
  'home.pricing.plan.combo.description': 'Weight training plus one modality of your choice.',
  'home.pricing.plan.annual.name': 'Full Annual Plan',
  'home.pricing.plan.annual.price': '12x R$ 130',
  'home.pricing.plan.annual.priceNote': 'on credit card',
  'home.pricing.plan.annual.description': 'All modalities included for 12 months.',
  'home.pricing.passes.title': 'Visiting Cumbuco?',
  'home.pricing.passes.subtitle': 'Flexible passes for visitors and tourists.',
  'home.pricing.passes.day': 'Day pass',
  'home.pricing.passes.dayPrice': 'R$ 35',
  'home.pricing.passes.week': 'Week',
  'home.pricing.passes.weekPrice': 'R$ 110',
  'home.pricing.passes.fortnight': 'Two weeks',
  'home.pricing.passes.fortnightPrice': 'R$ 130',
  'home.pricing.whatsappMessage': 'Hello! I am interested in the plan: ',

  'home.cta.label': 'START NOW',
  'home.cta.title': 'READY TO TRAIN IN CUMBUCO?',
  'home.cta.text': 'Get in touch with Top Gym and check plans, schedules and available modalities.',
  'home.cta.button': 'Message on WhatsApp',
};